import { Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useSnapshots } from './api/getSnapshots';

interface Props {
  analyzerId: number;
}

const TotalSweepTime = ({ analyzerId }: Props) => {
  const { data: snapshots } = useSnapshots({ analyzerId });

  const totalSweepTime = snapshots
    ?.filter((snapshot) => snapshot.enabled)
    ?.map((snapshot) => snapshot.last_reported_sweep_time)
    ?.reduce((prev, current) => Number(prev) + Number(current), 0);

  return (
    <Typography color={grey[500]} textAlign='left'>
      Total Sweep Time: {totalSweepTime || '0'} ms
    </Typography>
  );
};

export default TotalSweepTime;
